export const HELP_DESK_ALL = 'HELP_DESK_ALL';
export const HELP_DESK_SINGLE = 'HELP_DESK_SINGLE';
export const FETCH_START = 'FETCH_START';
export const FETCH_END = 'FETCH_END';
